import _ from 'underscore'
import dayjs from 'libraries/dayjs'

Date.prototype.format = function (format) {
  if (_.isUndefined(format)) {
    format = 'L';
  }
  return dayjs(this).format(format);
};
